const state = {
    productInfo: {},
    tslDataLocal: {
        schema: '',
        profile: {
            version: '1.0',
            productKey: '',
        },
        properties: [],
        events: [],
        services: [],
    },
    currentProduct: {
        productKey: '',
    },
};

const mutations = {
    SETCURRENTPRODUCT: (state, payload) => {

        state.currentProduct = payload;
    },
    SETPRODUCTINFO: (state, payload) => {
        state.productInfo = payload;
    },
    SERTSLDATALOCAL: (state, payload) => {
        state.tslDataLocal.profile.productKey = state.productInfo.productKey;
        const currentTslDataLocal = state.tslDataLocal;

        if (payload.code == 9999 && payload.type == 'events') {
            // 直接在数组上使用 push 方法
            currentTslDataLocal.events.push(payload.obj);
            // 更新 state.tslDataLocal
            state.tslDataLocal = { ...currentTslDataLocal };
        }
        if (payload.code == 9999 && payload.type == 'services') {
            currentTslDataLocal.services.push(payload.obj);
            state.tslDataLocal = { ...currentTslDataLocal };
        }

        if (payload.code == 9999 && payload.type == 'propertiesValue') {
            currentTslDataLocal.properties.push(payload.obj);
            currentTslDataLocal.events.forEach((item) => {
                if (item.identifier == 'post') {
                    item.outputData.push(payload.obj);
                }
            });
            currentTslDataLocal.services.forEach((item) => {
                if (payload.obj.accessMode == 'rw') {
                    if (item.identifier == 'set') {
                        item.inputData.push(payload.obj);
                    }
                    if (item.identifier == 'get') {
                        item.inputData.push(payload.obj.name);
                        item.outputData.push(payload.obj);
                    }
                }
            });
            state.tslDataLocal = { ...currentTslDataLocal };
        }

        if (payload.code == 2000) {
            state.tslDataLocal = payload.data;
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
